import gql from 'graphql-tag';

import {
  UserImages,
  AccountAddressFields,
  UserProSettings,
  UserNotificationSettings,
  UserTaxDetails,
  AccountReportDetails,
} from '../fragments/account';
import { LocationDetails } from '../fragments/location';

export const accountLogin = gql`
  mutation accountLogin($input: AccountLoginInput!) {
    accountLogin(input: $input) {
      success
      auth_token
    }
  }
`;

export const accountLoginByPhone = gql`
  mutation accountLoginByPhone($input: AccountLoginByPhoneInput!) {
    accountLoginByPhone(input: $input) {
      success
      existing_account
    }
  }
`;

export const accountCreateByEmail = gql`
  mutation accountCreateByEmail($input: AccountCreateByEmailInput!) {
    accountCreateByEmail(input: $input) {
      success
      auth_token
      account_id
    }
  }
`;

export const accountUpdate = gql`
  mutation accountUpdate($input: AccountUpdateInput!) {
    accountUpdate(input: $input) {
      account {
        id
        username
        email_address
        name
        phone_number
        contact_phone
        email_verified
        active
        organization_name
        site_url
        album_folder_groups_sort
        ...UserImages
        ...UserProSettings
        ...UserNotificationSettings
        ...UserTaxDetails
      }
    }
  }
  ${UserImages}
  ${UserProSettings}
  ${UserNotificationSettings}
  ${UserTaxDetails}
`;

export const accountDelete = gql`
  mutation accountDelete($input: AccountDeleteInput!) {
    accountDelete(input: $input) {
      success
    }
  }
`;

export const emailVerify = gql`
  mutation emailVerify($input: EmailVerifyInput!) {
    emailVerify(input: $input) {
      account {
        id
        email_verified
      }
    }
  }
`;

export const emailVerifyRequest = gql`
  mutation emailVerifyRequest($input: EmailVerifyRequestInput!) {
    emailVerifyRequest(input: $input) {
      success
    }
  }
`;

export const passwordResetRequest = gql`
  mutation passwordResetRequest($input: PasswordResetRequestInput!) {
    passwordResetRequest(input: $input) {
      success
    }
  }
`;

export const passwordReset = gql`
  mutation passwordReset($input: PasswordResetInput!) {
    passwordReset(input: $input) {
      success
    }
  }
`;

export const passwordUpdate = gql`
  mutation passwordUpdate($input: PasswordUpdateInput!) {
    passwordUpdate(input: $input) {
      success
    }
  }
`;

export const passwordCreate = gql`
  mutation passwordCreate($input: PasswordCreateInput!) {
    passwordCreate(input: $input) {
      success
    }
  }
`;

export const clientStoreSet = gql`
  mutation clientStoreSet($input: ClientStoreSetInputType!) {
    clientStoreSet(input: $input) {
      mutationId
    }
  }
`;

export const accountAddProRoles = gql`
  mutation accountAddProRoles($input: AccountAddProRolesInput!) {
    accountAddProRoles(input: $input) {
      account {
        id
        roles
      }
    }
  }
`;

export const requestProAccess = gql`
  mutation requestProAccess($input: RequestProAccessInput!) {
    requestProAccess(input: $input) {
      success
    }
  }
`;

export const assetImagesUpload = gql`
  mutation assetImagesUpload($input: AssetImagesUploadInput!) {
    assetImagesUpload(input: $input) {
      image_uploads {
        id
        url
      }
    }
  }
`;

export const accountImageAssetUpdate = gql`
  mutation accountImageAssetUpdate($input: AccountImageAssetUpdateInput!) {
    accountImageAssetUpdate(input: $input) {
      account {
        id
        ...UserImages
      }
    }
  }
  ${UserImages}
`;

export const accountAddressCreate = gql`
  mutation accountAddressCreate($input: AccountAddressCreateInput!) {
    accountAddressCreate(input: $input) {
      account_address {
        ...AccountAddressFields
      }
    }
  }
  ${AccountAddressFields}
`;

export const accountAddressUpdate = gql`
  mutation accountAddressUpdate($input: AccountAddressUpdateInput!) {
    accountAddressUpdate(input: $input) {
      account_address {
        ...AccountAddressFields
      }
    }
  }
  ${AccountAddressFields}
`;

export const accountAddressDelete = gql`
  mutation accountAddressDelete($input: AccountAddressDeleteInput!) {
    accountAddressDelete(input: $input) {
      account_address {
        id
      }
    }
  }
`;

export const accountUpdatePhoneNumber = gql`
  mutation accountUpdatePhoneNumber($input: AccountUpdatePhoneNumberInput!) {
    accountUpdatePhoneNumber(input: $input) {
      account {
        id
        phone_number
      }
    }
  }
`;

export const phoneVerificationRequest = gql`
  mutation phoneVerificationRequest($input: PhoneVerificationRequestInput!) {
    phoneVerificationRequest(input: $input) {
      success
      captcha_result {
        allow_action
        challenge_user
      }
    }
  }
`;

export const emailAuthenticationRequest = gql`
  mutation emailAuthenticationRequest(
    $input: EmailAuthenticationRequestInput!
  ) {
    emailAuthenticationRequest(input: $input) {
      success
    }
  }
`;

export const albumFolderAccessRequest = gql`
  mutation albumFolderAccessRequest($input: AlbumFolderAccessRequestInput!) {
    albumFolderAccessRequest(input: $input) {
      success
      auto_added_members
    }
  }
`;

export const accountAddRoles = gql`
  mutation accountAddRoles($input: AccountAddRolesInput!) {
    accountAddRoles(input: $input) {
      account {
        id
        roles
      }
    }
  }
`;

export const accountLoginByEmail = gql`
  mutation accountLoginByEmail($input: AccountLoginByEmailInput!) {
    accountLoginByEmail(input: $input) {
      success
      auth_token
      existing_account
      account {
        id
      }
    }
  }
`;

export const referralSignupInvitationsSend = gql`
  mutation referralSignupInvitationsSend(
    $input: ReferralSignupInvitationsSendInput!
  ) {
    referralSignupInvitationsSend(input: $input) {
      success
    }
  }
`;

export const accountLoginByOAuth = gql`
  mutation accountLoginByOAuth($input: AccountLoginByOAuthInput!) {
    accountLoginByOAuth(input: $input) {
      success
    }
  }
`;

export const accountLocationCreate = gql`
  mutation accountLocationCreate($input: AccountLocationCreateInput!) {
    accountLocationCreate(input: $input) {
      account_location {
        id
        radius(distance_unit: MILES) {
          value
          unit
        }
        location {
          id
          ...LocationDetails
        }
      }
    }
  }
  ${LocationDetails}
`;

export const accountLocationDelete = gql`
  mutation accountLocationDelete($input: AccountLocationDeleteInput!) {
    accountLocationDelete(input: $input) {
      success
    }
  }
`;

export const AccountBlockedAccountCreate = gql`
  mutation accountBlockedAccountCreate(
    $input: AccountBlockedAccountCreateInput!
  ) {
    accountBlockedAccountCreate(input: $input) {
      account_blocked_account {
        id
      }
    }
  }
`;

export const AccountBlockedAccountDelete = gql`
  mutation accountBlockedAccountDelete(
    $input: AccountBlockedAccountDeleteInput!
  ) {
    accountBlockedAccountDelete(input: $input) {
      success
    }
  }
`;

export const signupEventCreateReminderSet = gql`
  mutation signupEventCreateReminderSet(
    $input: SignupEventCreateReminderSetInput!
  ) {
    signupEventCreateReminderSet(input: $input) {
      success
    }
  }
`;

export const eventAddonPurchaseReminderSet = gql`
  mutation eventAddonPurchaseReminderSet(
    $input: EventAddonPurchaseReminderSetInput!
  ) {
    eventAddonPurchaseReminderSet(input: $input) {
      success
    }
  }
`;

export const photoManagerPurchaseReminderSet = gql`
  mutation photoManagerPurchaseReminderSet(
    $input: PhotoManagerPurchaseReminderSetInput!
  ) {
    photoManagerPurchaseReminderSet(input: $input) {
      success
    }
  }
`;

export const accountReportCreate = gql`
  mutation accountReportCreate($input: AccountReportCreateInput!) {
    accountReportCreate(input: $input) {
      account_report {
        ...AccountReportDetails
      }
    }
  }
  ${AccountReportDetails}
`;
